import { BaseCatalogUsecase } from './Base'

export class FilterCatalogServicesUsecase extends BaseCatalogUsecase {
    invoke (search: string): void {
        this.setCatalog({ search })
    }
}
